export default {
    ritten(state){
        return state.ritten;
    },
    hasRitten(state){
        return state.ritten && state.ritten.length;
    },

    pages(state){
        return state.pages;
    }
}